<template>
    <div class="wrap">
        <!-- 顶部导航栏-->
        <my-header title="毕业去向统计"></my-header>
        <!--头部-->
        <div class="hd">
            <p>
                截至{{transDay(orginfo.updateTime)}}，{{orginfo.leagueId==TzyLeagueId?'全国':orginfo.leagueName}}共有毕业生团员数：{{orginfo.leagueMemberCount|numShow}}人，
                已发起转出团员数：{{orginfo.transferMemberCount|numShow}}人，
                其中，升学：{{orginfo.sXMemberCount|numShow}}人，<span v-if="orginfo.sXMemberCount>0">占已发起的{{percent(orginfo.sXMemberCount,orginfo.transferMemberCount)}}；</span>
                已落实工作单位（工作单位有团组织）：{{orginfo.unitMemberCount|numShow}}人，<span v-if="orginfo.unitMemberCount>0">占已发起的{{percent(orginfo.unitMemberCount,orginfo.transferMemberCount)}}；</span>
                已落实工作单位（工作单位无团组织）：{{orginfo.unitNoMemberCount|numShow}}人，<span
                    v-if="orginfo.unitNoMemberCount        >0">占已发起的{{percent(orginfo.unitNoMemberCount,orginfo.transferMemberCount)}}；</span>
                出国（因公出国／境）：{{orginfo.abMemberCount|numShow}}人，<span v-if="orginfo.abMemberCount>0">占已发起的{{percent(orginfo.abMemberCount,orginfo.transferMemberCount)}}；</span>
                出国（境）学习研究：{{orginfo.abSMemberCount|numShow}}人，<span v-if="orginfo.abSMemberCount>0">占已发起的{{percent(orginfo.abSMemberCount,orginfo.transferMemberCount)}}；</span>
                出国（因私出国／境）：{{orginfo.abPMemberCount|numShow}}人，<span v-if="orginfo.abPMemberCount>0">占已发起的{{percent(orginfo.abPMemberCount,orginfo.transferMemberCount)}}；</span>
                未就业：{{orginfo.unMemberCount|numShow}}人，<span v-if="orginfo.unMemberCount>0">占已发起的{{percent(orginfo.unMemberCount,orginfo.transferMemberCount)}}；</span>
                转往特殊单位团组织：{{orginfo.spMemberCount|numShow}}人，<span v-if="orginfo.spMemberCount>0">占已发起的{{percent(orginfo.spMemberCount,orginfo.transferMemberCount)}}；</span>
                <span v-if="orginfo.gzMemberCount>0">工作：{{orginfo.gzMemberCount|numShow}}人，占已发起的{{percent(orginfo.gzMemberCount,orginfo.transferMemberCount)}}；</span>
                <span v-if="orginfo.bqMemberCount>0">搬迁：{{orginfo.bqMemberCount|numShow}}人，占已发起的{{percent(orginfo.bqMemberCount,orginfo.transferMemberCount)}}；</span>
                <span v-if="orginfo.qtMemberCount>0">其他：{{orginfo.qtMemberCount |numShow}}人，占已发起的{{percent(orginfo.qtMemberCount ,orginfo.transferMemberCount)}}；</span>
                具体情况见下表：
            </p>
        </div>

        <!-- 内容部分-->
        <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
        >
            <van-cell v-if="isOrg">
                <div class="content" v-for="item in dataList" :key="item.leagueId">
                    <div class="content_hd">
                        <div class="orgName">
                            <span class="line"></span>
                            <p>{{item.leagueName}}</p>
                        </div>
                        <div v-if="item.leagueMemberCount>0">
                            <van-button color="#72b7f2"
                                        v-if="item.leagueTypeId!='06BYBTZB'&&item.leagueTypeId!='01TZB'"
                                        @click="nextclick=true;getdata(1,item.leagueId)">查看
                            </van-button>
                            <van-button color="#72b7f2" v-else
                                        @click="nextclick=true;getdata1(1,item.leagueId)">查看
                            </van-button>

                        </div>
                        <div v-else style="flex:0 0 60px">
                            <van-button color="#dcdcdc">查看</van-button>
                        </div>
                    </div>
                    <div class="content_bd">
                        <div>

                            <p class="title">组织类别</p>
                            <p class="s_title">{{orgCates[item.leagueTypeId]}}</p>
                        </div>
                        <div>

                            <p class="title">所属行业类别</p>
                            <p class="s_title" style="text-align: right">{{orgIndustry[item.industryTypeId]}}</p>
                        </div>
                    </div>
                    <div class="content_fd">
                        <div class="enterRate">
                            <p class="s_title">转出发起率</p>
                            <p class="red_">{{transferPer(item)}}</p>
                        </div>
                        <div class="enterRate">

                            <p class="s_title">毕业生团员数</p>
                            <p class="yellow_">{{item.leagueMemberCount}}</p>
                        </div>
                        <div class="enterRate">

                            <p class="s_title">已发起转出团员数</p>
                            <p class="yellow_">{{transCount(item)}}</p>
                        </div>

                    </div>
                </div>

            </van-cell>


            <van-cell v-else>
                <div class="content" v-for="item in dataList1" :key="item.leagueId">
                    <div class="content_hd">
                        <div class="orgName">
                            <span class="line"></span>
                            <p>{{item.name}}</p>
                        </div>
                        <div style="flex:0 0 60px">
                            <van-button  color="#72b7f2" v-if="item.transferReason!=308&&item.isCSDE!=1" @click="baseUserInfo(item)">查看
                            </van-button>
                            <van-button  color="#72b7f2" v-else-if="item.isCSDE==1&&item.transferStatus!=2" @click="baseUserInfo(item)">查看
                            </van-button>
                            <van-button  color="#dcdcdc" v-else>查看</van-button>
                        </div>
                    </div>
                    <div class="content_fd">
                        <div class="enterDetail">
                            <div class="tzbDetail">
                                <p class="b_title">成员身份</p>
                                <p class="s_title">{{formatGraduationType(item)}}</p>
                            </div>
                            <div class="tzbDetail">

                                <p class="b_title">组织关系转接状态</p>
                                <p class="s_title">{{formatTransferStatus(item)}}</p>
                            </div>
                            <div class="tzbDetail">

                                <p class="b_title">接转类型</p>
                                <p class="s_title">{{formatTransferReason(item)}}</p>
                            </div>
                            <div class="tzbDetail">

                                <p class="b_title">转入团组织</p>
                                <p class="s_title">{{formatLeagueName(item)}}</p>
                            </div>


                        </div>
                    </div>
                </div>

            </van-cell>


        </van-list>

    </div>


</template>

<script>
    import MyHeader from '../../components/MyHeader'
    import {mapState} from 'vuex'
    import cons from '../../cons.vue'
    import {Toast} from 'vant';

    export default {
        name: "transferProcessMonitor",
        components: {MyHeader},
        data() {
            return {
                value: 0,
                option: [
                    {text: '“学社衔接”率', value: 0},
                    {text: '“升学衔接”率', value: 1},
                    {text: '转出统计数据', value: 2},
                    {text: '单位团组织转接率', value: 3},
                    {text: '按类别转出情况', value: 4},
                ],
                list: [],
                loading: false,
                finished: false,
                dataList: [],
                dataList1: [],
                queryLeagueId: "",
                isOrg: true,
                orgCates: {},
                orgIndustry: {},
                historyList: [],
                nextclick: false,

                orginfo: {},


                page: 1,
                rowsPrePage: 2,
                totalRows: 3,

                page2: 1,
                rowsPrePage2: 2,
                totalRows2: 3,
            }
        },
        created() {
            this.queryLeagueId = this.curLeague.leagueId
            this.getdata(1, this.queryLeagueId)
        },
        computed: {
            ...mapState({
                commonparams: state => state.commonparams,
                curUser: state => state.user,
                curLeague: state => state.league
            }),


        },
        methods: {
            onLoad() {
                this.loading = true
                if(this.isOrg){
                    if (this.page * this.rowsPrePage < this.totalRows) {
                        this.page++
                        this.getdata(this.page)
                    }else {
                        this.finished=true
                    }
                }else{
                    if (this.page2 * this.rowsPrePage2 < this.totalRows2) {
                        this.page2++
                        this.getdata1(this.page2)
                    }else {
                        this.finished=true
                    }
                }

            },
            baseUserInfo(row) {
                row.leagueId=this.queryLeagueId
                this.$store.commit('SET_PARAMS', {'/mine/baseInfo': Object.assign({}, row)})

                this.jump('/mine/baseInfo')
            },
            //本组织统计数据查询
            getdata(page, queryLeagueId) {
                this.isOrg = true
                this.loading = true
                if (!queryLeagueId) {
                    queryLeagueId = this.queryLeagueId
                }
                let param = new FormData()
                // param.append('currUserId', this.curUser.userId)
                // param.append('currLeagueId', this.curLeague.leagueId)

                param.append('statisticalLeagueId', queryLeagueId)


                param.append('page', page)

                this.$root.PF('/school/getGraduateMemberOrgList', param, {baseURL: cons.u})
                    .then(response => {
                        this.loading = false
                        if (response.status == 200) {
                            if (response.data.retCode === 1000) {

                                if (this.nextclick) {
                                    this.historyList.push(this.queryLeagueId)
                                    this.nextclick = false
                                }
                                this.queryLeagueId = queryLeagueId

                                this.orginfo = response.data.results.resp

                                this.dataList = this.orginfo.childGraduateMemberInfoList
                                this.orgCates = response.data.results.leagueTypes
                                this.orgIndustry = response.data.results.industrytypes

                                this.page = this.orginfo.page
                                this.rowsPrePage = this.orginfo.pageNumber
                                this.totalRows = this.orginfo.totalNumber

                            } else {
                                this.loading = false
                                Toast.fail(response.data.retMsg);
                                console.log("reCode:" + response.data.retCode)
                            }
                        } else {
                            this.loading = false
                            console.log("Got Return code:" + response.status)
                        }
                    })
                    .catch(error => {
                        this.loading = false
                        if (error.response) {

                            console.log(error.response.data);
                            console.log(error.response.status);
                            console.log(error.response.headers);

                        } else if (error.request) {
                            console.log(error.request);

                        } else {
                            console.log('Error', error.message);
                        }
                        console.log(error.config);
                    });
            },

            //下级组织统计数据查询
            getdata1(page, queryLeagueId) {

                this.isOrg = false
                this.loading = true
                if (!queryLeagueId) {
                    queryLeagueId = this.queryLeagueId
                }
                let param = new FormData()
                // param.append('currUserId', this.curUser.userId)
                // param.append('currLeagueId', this.curLeague.leagueId)

                param.append('statisticalLeagueId', queryLeagueId)


                param.append('page', page)

                this.$root.PF('/school/getGraduateMemberInfoList', param, {baseURL: cons.u})
                    .then(response => {
                        this.loading = false
                        if (response.status == 200) {
                            if (response.data.retCode === 1000) {
                                if (this.nextclick) {
                                    this.historyList.push(this.queryLeagueId)
                                    this.nextclick = false
                                }
                                this.queryLeagueId = queryLeagueId
                                this.orginfo = response.data.results
                                this.dataList1 = this.orginfo.childMemberInfoList

                                this.page2 = this.orginfo.page
                                this.rowsPrePage2 = this.orginfo.pageNumber
                                this.totalRows2 = this.orginfo.totalNumber
                            } else {
                                this.loading = false
                                this.$toast.fail({
                                    message: response.data.retMsg,
                                })
                                console.log("reCode:" + response.data.retCode)
                            }
                        } else {
                            this.loading = false
                            console.log("Got Return code:" + response.status)
                        }
                    })
                    .catch(error => {
                        this.loading = false
                        if (error.response) {

                            console.log(error.response.data);
                            console.log(error.response.status);
                            console.log(error.response.headers);

                        } else if (error.request) {
                            console.log(error.request);

                        } else {
                            console.log('Error', error.message);
                        }
                        console.log(error.config);
                    });
            },

            //已发起转出团员数
            transCount(row) {

                if (row.leagueMemberCount == 0) {
                    return "-";
                }
                return row.transferMemberCount;

            },

            //结转率计算
            transferPer(row) {
                let leagueMemberCount = row.leagueMemberCount;
                let transferMemberCount = row.transferMemberCount;
                if (leagueMemberCount == 0) {
                    return "-";
                }

                return this.percent(transferMemberCount, leagueMemberCount)
            },
            percent(value1, value2) {
                console.log(value1 + "   " + value2)
                if (value2 == 0 || value2 == "—") {
                    return "—"
                } else if (value1 == 0) {
                    return "0%";
                } else if (value1 == value2) {
                    return "100%"
                } else {
                    var num = (value1 / value2);
                    var s = num * 100;
                    if (s > 99.5 && s < 100) {
                        return "99.9%"
                    } else if (s < 0.1) {
                        return "0.1%"
                    } else {
                        return "" + (s.toFixed(1)) + "%";
                    }
                }
            },
            formatGraduationType(row) {
                if (row.graduationType == 0) {
                    return "非毕业生";
                } else if (row.graduationType == 1) {
                    return "毕业生";
                } else if (row.graduationType == 2) {
                    return "教师";
                } else if (row.graduationType == 3) {
                    return " 延迟毕业生";
                }
                return ''
            },
            // 尚未转接、转接中、转接完成、转接被退回
            formatTransferStatus(row) {
                // 教师 非毕业生 不显示
                if (row.graduationType == 0 || row.graduationType == 2) {
                    return "—";
                }
                switch (row.transferStatus) {
                    case 0:
                        return "尚未转接"
                    // case 4:
                    //     return "申请人撤销"
                    case 4:
                        return "尚未转接"
                    case 5:
                        return "转接被退回"
                    case 1:
                        return "转接中"
                    case 2:
                        return "转接完成"
                    case 3:
                        return "转接被退回"
                    case 6:
                        return "转接被退回"
                }

            },
            formatTransferReason(row) {
                if (row.transferStatus != 1 && row.transferStatus != 2) {
                    return "—";
                }
                if (row.graduationType == 0 || row.graduationType == 2) {
                    return "—";
                }
                if (row.graduationType == 3) {
                    return '非“学社衔接”';
                }

                switch (row.transferReason) {
                    case 201:
                        return "升学"
                    case 202:
                        return "工作"
                    case 203:
                        return "搬迁"
                    case 204:
                        return "转往特殊单位团组织"
                    case 205:
                        return "其他"
                    case 301:
                        return "升学"
                    case 302:
                        return "已落实工作单位（工作单位有团组织）"
                    case 303:
                        return "已落实工作单位（工作单位无团组织）"
                    case 304:
                        return "出国（因公出国／境）"
                    case 305:
                        return "出国（境）学习研究"
                    case 306:
                        return "出国（因私出国／境）"
                    case 307:
                        return "未就业"
                    case 308:
                        return "转往特殊单位团组织"
                    default:
                        return "—"
                }

            },
            formatLeagueName(row) {
                if (row.transferStatus != 1 && row.transferStatus != 2) {
                    return "—";
                }
                if (row.graduationType == 0 || row.graduationType == 2) {
                    return "—";
                }
                if (row.transferStatus == 1 || row.transferStatus == 2) {
                    if (row.transferReason == 204) {
                        return '—'
                    }
                    return row.leagueFullname
                } else {
                    return '—'

                }
            },
        },
        filters: {
            numShow(num) {
                if (num == -1) {
                    return '(统计中)'
                }
                return num
            }
        },
    }
</script>

<style scoped>
    .wrap {
        background-color: #eeedf0;
        height: 100%;
    }

    .hd {
        padding: 60px 15px 0;
        font-size: 14px;
        text-indent: 2em;
        color: #656565;
    }

    .hd .red {
        color: #e32322;
    }

    .content {
        display: flex;
        flex-direction: column;
        width: 90%;
        margin: 10px auto;
        padding: 10px;
        border-radius: 5px;
        background-color: white;
        margin-bottom: 10px;
    }

    .content_hd {
        border-bottom: 1px solid gainsboro;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 5px;
    }

    /*.content_hd van-button{*/
    /*    font-size: 13px;*/
    /*    height: 20px;*/
    /*}*/
    .content_hd p {
        font-size: 16px;
        margin: 0 10px;
        /*font-weight: bold;*/
    }

    .content_hd .orgName {
        display: flex;
        align-items: center;
        flex: 1;
    }

    .content_hd .line {
        display: inline-block;
        flex: 0 0 2px;
        height: 20px;
        background-color: #e32322;
    }

    .content_bd {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid gainsboro;
        padding: 0 10px;
    }

    .content_bd .title {
        font-size: 14px;
        margin-bottom: 0;
    }

    .content_bd .s_title {
        margin-top: 0;
    }

    .content_fd {
        padding: 10px;
    }

    .content_fd .enterRate {
        display: flex;
        text-align: center;
        justify-content: space-between;
        margin-right: 20px;
        /*padding: 10px 0;*/
    }

    .content_fd .enterRate3 {
        flex: 0 0 100px;
        text-align: center;
        margin-right: 20px;
        /*padding: 10px 0;*/
    }

    .content_fd .enterDetail {
        flex: 1;
        /*padding-top: 8px;*/
    }

    .content_fd .enterDetail div {
        display: flex;
        justify-content: flex-start;
    }

    .content_fd p {
        padding: 0px;
        margin: 5px 0;
    }

    .content_fd .enterDetail p {
        margin-left: 20px;
    }

    .tzbDetail {
        display: flex;
    }

    .tzbDetail .b_title {
        flex: 0 0 120px;
        color: #434343;
        font-size: 13px;
    }

    .red_ {
        color: #e32322;
        font-size: 13px;
        text-align: center;
    }

    .yellow_ {
        color: #ffa800;
        font-size: 13px;
    }

    .s_title {
        color: #656565;
        font-size: 13px;
    }


    /deep/ .van-dropdown-menu__bar {
        background-color: transparent;
        box-shadow: none;
    }

    /*/deep/ .van-ellipsis {*/
    /*    color: #e32322;*/
    /*}*/
    /*/deep/ .van-dropdown-menu__title::after{*/
    /*    border-color: transparent transparent #e32322 #e32322;*/
    /*}*/
    /deep/ .van-button {
        height: 20px;
        width: 100%;
        font-size: 12px;
        padding: 10px 16px;
        border-radius: 5px;
    }

    /deep/ .van-button--hairline::after {
        border-radius: 10px;
    }

    /*/deep/ .van-dropdown-item__content{*/
    /*    width: 50%;*/
    /*}*/
    /deep/ .van-list {
        background-color: #eeedf0;
    }

    /deep/ .van-list .van-cell {
        background-color: transparent;
        padding: 0px;
    }

</style>
